import type { ReactNode, SVGProps } from "react";

export function WarningIcon(props: SVGProps<SVGSVGElement>): ReactNode {
	return (
		<svg
			fill="none"
			height="14"
			viewBox="0 0 16 14"
			width="16"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M7.625 5.01025V7.7803"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M6.47921 1.26434L0.804562 10.6368C0.68758 10.8372 0.625675 11.0644 0.625005 11.2958C0.624336 11.5272 0.684924 11.7548 0.800744 11.9558C0.916564 12.1569 1.08358 12.3245 1.28518 12.4419C1.48678 12.5593 1.71593 12.6224 1.94985 12.625H13.3005C13.5344 12.6223 13.7634 12.5592 13.9649 12.4418C14.1664 12.3245 14.3334 12.157 14.4492 11.956C14.565 11.7551 14.6256 11.5276 14.625 11.2963C14.6244 11.065 14.5626 10.8379 14.4458 10.6375L8.77119 1.26365C8.6518 1.06871 8.48361 0.90752 8.28287 0.795647C8.08212 0.683775 7.85561 0.625 7.6252 0.625C7.39479 0.625 7.16828 0.683775 6.96753 0.795647C6.76679 0.90752 6.5986 1.06871 6.47921 1.26365"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M7.625 9.85767H7.632"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
		</svg>
	);
}
